import SettingsPageHeader from "@/components/molecules/SettingsPageHeader";

interface AuditProps {
  id: string;
  dateTime: string;
  admin: string;
  action: string;
  details: string;
}

const AUDIT_TABLE_HEADERS = ["Date & Time", "Admin", "Action", "Details"];

const MOCK_AUDIT_LOGS: AuditProps[] = [
  {
    id: "1",
    dateTime: "2025-09-18 10:30 AM",
    admin: "Alice Johnson",
    action: "User Role Updated",
    details: "-",
  },
  {
    id: "1",
    dateTime: "2025-09-18 10:30 AM",
    admin: "Alice Johnson",
    action: "User Role Updated",
    details: "-",
  },
];

const AuditTableRow = ({ log }: { log: AuditProps }) => {
  return (
    <tr className="text-white">
      <td className="py-3 px-4">{log.dateTime}</td>
      <td className="py-3 px-4">{log.admin}</td>
      <td className="py-3 px-4">{log.action}</td>
      <td className="py-3 px-4">{log.details}</td>
    </tr>
  );
};

const Audit = () => {
  return (
    <div>
      <SettingsPageHeader title="Audit Logs" />
      <div>
        <table className="w-full table-auto border-collapse">
          <thead>
            <tr className="">
              {AUDIT_TABLE_HEADERS.map((header) => (
                <th
                  key={header}
                  className="py-3 px-4 text-left text-sm font-medium text-white"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {MOCK_AUDIT_LOGS.map((log) => (
              <AuditTableRow key={log.id} log={log} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Audit;
